import { render } from "./AppSimpleTable.vue?vue&type=template&id=ece284c0&scoped=true"
import script from "./AppSimpleTable.vue?vue&type=script&lang=js"
export * from "./AppSimpleTable.vue?vue&type=script&lang=js"

import "./AppSimpleTable.vue?vue&type=style&index=0&id=ece284c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ece284c0"]])

export default __exports__